/**
 * Created by mykurisu on 2017/7/16.
 */
import React from 'react'
import {connect} from 'react-redux'
import {Link, browserHistory} from 'react-router'
import { isLZWKAPP } from '../../utils'
import { toShareCardPage } from '../../utils/connectApp'
import '../../styles/component.css'
import ShareCardGiftIcon from '../../images/share-gift-icon.png'
import ShareCardMoneyIcon from '../../images/sharecard-money.png'

class WKToShareCard extends React.Component {

    componentDidMount() {
        // 支付宝客户端不显示"邀请好友"
        if (window.platform === 'alipay') {
            return
        }

        // let item = document.querySelector('.share-card-entry');
        // item.addEventListener('webkitAnimationEnd', () => {
        //     this.props.dispatch({
        //         type: 'SHARECARD_ANIMATION'
        //     });
        //     this.props.dispatch({
        //         type: 'SHARECARD_SLIDE',
        //         payload: 87
        //     });
        //     setTimeout(() => {
        //         this.props.dispatch({
        //             type: 'SHARECARD_TRANSITION'
        //         })
        //     },300)
        // })
    }

    toShareCard (e) {
        const {sharecard} = this.props
        if (isLZWKAPP()) {
            e.preventDefault()
            toShareCardPage(sharecard.type, sharecard.id)
        } else {
            if(/liveroom/.test(window.location.pathname) && sharecard.role.is_manager && !sharecard.role.is_sub_manager){
                window.location.href = `/activity/lecturer_card`;
            }else{
                location.assign(`/${sharecard.type}/${sharecard.id}/sharecard/${window.location.search.indexOf('is_resell_center')>-1 ? '?is_resell_center=True': '' }`)
            }
        }
    }

    render() {
        const {sharecard} = this.props;
        // let is_wy = false;
        // if (sharecard.type === 'channel' && Number(sharecard.id) === 123444){
        //     is_wy = true
        // }
        // if (sharecard.type === 'lecture'){
        //     switch (Number(sharecard.id)){
        //         case 5449654:
        //             is_wy = true;
        //             break;
        //         case 5449808:
        //             is_wy = true;
        //             break;
        //         case 5449822:
        //             is_wy = true;
        //             break;
        //         case 5449838:
        //             is_wy = true;
        //             break;
        //         default:
        //             is_wy = false;
        //             break;
        //     }
        // }

        // 支付宝客户端不显示"邀请好友"
        if (window.platform === 'alipay') {
            return null
        }

        if (sharecard.id === '') {
            return null
        }

        return (
            <Link onClick={e => this.toShareCard(e)}>
                <div className="sharecard__entry-global" style={{top: this.props.top == null ? sharecard.top : this.props.top}}>
                    <div className="sharecard__entry">
                        <div className="sharecard__entry-icon">
                            <img src={sharecard.is_resell ? ShareCardMoneyIcon : "https://static-1253442168.image.myqcloud.com/picture/5459246_112eef31aae9a8de182b5838c3883599.jpg"} alt=""/>
                        </div>
                        {sharecard.title ? `${sharecard.title}元` : '邀请卡'}
                    </div>
                </div>
            </Link>
        )

        return (
            <Link onClick={e => this.toShareCard(e)}>
                <div className="share-card-entry-global" style={{top: sharecard.top}}>
                    {false &&
                    <div className="share-card-entry-animation">
                        <div className={sharecard.animated ? 'share-card-entry' : 'share-card-entry share-card-entry_animate'} onClick={this.handleShareLink}
                             style={{width: sharecard.width + 'px', transition: sharecard.transition}}>
                            <div className="share-card-get_qrcode?object_identry_text">
                                {sharecard.title ? sharecard.title : '邀请好友'}
                            </div>
                        </div>
                        <div className={sharecard.is_resell ? "share-card-entry_icon-money" : "share-card-entry_icon-gift"}>
                            <img className={sharecard.is_resell ? "share-card-entry_icon-money-animation" : ''} src={sharecard.is_resell ? ShareCardMoneyIcon : ShareCardGiftIcon} alt=""/>
                        </div>
                    </div>
                    }
                    <div className="share-card-entry-animation">
                        <div className={sharecard.animated ? 'share-card-entry' : 'share-card-entry share-card-entry_animate'} onClick={this.handleShareLink}
                             style={{width: sharecard.width + 'px', transition: sharecard.transition}}>
                            <div className="share-card-entry_text">
                                邀请好友
                            </div>
                        </div>
                        <div className="share-card-entry_icon-gift">
                            <img src={ShareCardGiftIcon} alt=""/>
                        </div>
                    </div>
                </div>
            </Link>
        )
    }
}

export default connect(state => ({
    sharecard: state.sharecard,
}))(WKToShareCard)


// WEBPACK FOOTER //
// ./src/components/wk/WKToShareCard.js